import { render } from "./VendorDetailsSearch.vue?vue&type=template&id=afbbc278"
import script from "./VendorDetailsSearch.vue?vue&type=script&lang=js"
export * from "./VendorDetailsSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__